<template>
	<v-container class="mt-12 pt-8" style="background:#fafafa;">
		<v-row style="background:#fafafa;">
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5">
					<v-col cols="12" md="3" LeadsPannel>
            <Product v-if="product && product.id" :item="product" :extend="true"  @reloadData="reload"/>
					</v-col>
					<v-col cols="12" md="9" LeadsPannel>
            <v-row class="align-center">
              <v-col cols="12" class="py-0">
                <v-card :loading="loading">
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">description</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{i18n['new_purchaseOrder']}}
                            </div>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">{{ i18n['product'] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class=" py-0" :class="`${arabic ? 'arFont' : 'enFont'}`" >
                        <Form v-if="!loading" @store="onSubmit" @update="updateSubmit" :resource="product" :countries="countries" :all_countries="all_countries" :tags="tags" :loading="loading" @reload="reload" />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              
            </v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Form from './Form.vue';
import Product from './Product.vue'
export default {
	components: {
    Product,
		Form,
	},
	data() {
		return {
			loading: false,
			product:{},
      countries:[],
      all_countries:[],
      tags:[],
		};
	},
	methods: {
		async onSubmit() {
			this.loading = true
			const {product} = await this.$store.dispatch('postResource', { resource: '/wholesale-products', value: {...this.product }})
			this.$router.push(`/wholesale-product/${product.id}/edit`)
			this.loading = false
		},
    async updateSubmit() {
			this.loading = true
			await this.$store.dispatch('putResource', { resource: '/wholesale-products/' + this.product.id, value: {...this.product }})
      await this.init()
			this.loading = false
		},

    async reload(){
      await this.init()
    },
    async init(){
      this.loading = true
      if(this.$route.params.page) {
        const posData = await this.$store.dispatch('getResource', { resource: `/wholesale-products/${this.$route.params.page}` })
        this.product = posData.product
        this.countries = posData.countries.map(x=>{return {...x, text:this.countryTranslation[x.alpha2Code.toLowerCase()]}})
        this.all_countries = posData.all_countries.map(x=>{return {...x,text:x.name}})
        this.tags = posData.tags.map(x=>{return{...x, text:`${x.en} | ${x.ar}`}})
      } else {
        const posData = await this.$store.dispatch('getResource', { resource: `/wholesale-data` })
        console.log(posData)
        this.countries = posData.countries.map(x=>{return {...x, text:this.countryTranslation[x.alpha2Code.toLowerCase()]}})
        this.all_countries = posData.all_countries.map(x=>{return {...x,text:x.name}})
        this.tags = posData.tags.map(x=>{return{...x, text:`${x.en} | ${x.ar}`}})
      }
      this.loading = false
    }
	},
  watch:{
    async $route (to, from){
      await this.init()

    },
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
    countryTranslation(){
      return this.$store.state.countries_[this.language];

    }
  },
  async created() {
    await this.init()
  }
}
</script>